

export const Theme = {
    font: {
        main: "'Roboto', sans-serif"
    }
}